// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { ModelClassMessage } from '@tls/sw91-communication/types/com.base';
import { ClassInformation } from '@tls/sw91_ui_templates/lib/models/model-information';

/**
 * Maps model class messages to class information objects
 * @param modelClasses - Array of model class messages
 * @returns Array of class information objects
 */
export function mapModelClassesToLabelClasses(modelClasses?: ModelClassMessage[]): ClassInformation[] {
  if (!modelClasses) return [];
  return modelClasses
    .filter(
      modelClass =>
        modelClass.classIndex !== undefined && modelClass.className !== undefined && modelClass.labelColor !== undefined
    )
    .map(modelClass => ({
      name: modelClass.className as string,
      index: modelClass.classIndex as number,
      color: [modelClass.labelColor?.red ?? 0, modelClass.labelColor?.green ?? 0, modelClass.labelColor?.blue ?? 0],
    }));
}
